// extracted by css-extract-rspack-plugin
export default {"cls1":"ViewAllSuggestions-cls1_KjA","cls2":"ViewAllSuggestions-cls2_2Us ViewAllSuggestions-cls1_KjA"};